import React, { Component } from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { FiChevronRight } from "react-icons/fi";
import Carousel from "react-multi-carousel";
import { Modal, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import { confirm, login } from "../../../features/auth/services";
import fix_numbers from "../../utils/fix_numbers";
import { navigate_to_edit_profile } from "../../../navigator/user/profile";
import { isSiteDomain } from "../../../settings/domainManager";

class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codeModal: false,
      phoneModal: true,
      showSlider: false,
      pending: false,
      err406: false,
      phone: this.props.phone,
      loginToken: "",
      expire_time: "",
      code: "",
      shopUid: window.location.pathname.split("/")[2],
      responsive: {
        all: {
          breakpoint: { min: 0, max: 4000 },
          items: 1,
        },
      },
      introItems: null,
    };
    this.codeInput = React.createRef();
    this.timer = null;
  }
  componentDidMount() {
    localStorage.removeItem(`${window.location.hostname}_token`);
    let login_items = localStorage.getItem("login_items");
    if (login_items) {
      try {
        this.setState({ introItems: JSON.parse(login_items) });
      } catch {}
    }
  }
  componentDidUpdate() {
    let login_items = localStorage.getItem("login_items");
    if (login_items && !this.state.introItems) {
      try {
        this.setState({ introItems: JSON.parse(login_items) });
      } catch {}
    }
  }
  componentWillReceiveProps() {
    if (localStorage.getItem("loginModal")) {
      this.setState({ phoneModal: true });
      if (document.getElementById("product-" + this.props.productId)) {
        document.getElementById(
          "product-" + this.props.productId
        ).disabled = false;
      }
    }
  }

  submitPhone() {
    this.setState({ pending: true });
    login(fix_numbers.fixNumbers(this.state.phone)).then((loginRes) => {
      if (loginRes && loginRes.status === 200)
        this.setState(
          {
            loginToken: loginRes.data.token,
            expire_time: loginRes.data.expire_time,
            editPhoneModal: false,
            codeModal: true,
            pending: false,
          },
          () => {
            this.timer = setInterval(() => {
              this.state.expire_time > 0
                ? this.setState({
                    expire_time: Number(this.state.expire_time) - 1,
                  })
                : clearInterval(this.timer);
            }, 1000);
          }
        );
      else {
        this.setState({ pending: false });
        Swal.fire({
          text: "شماره نامعتبر است",
          icon: "error",
          confirmButtonText: "تایید",
        });
      }
    });
  }
  submitCode() {
    this.setState({ pending: true, err406: false });
    confirm(
      fix_numbers.fixNumbers(this.state.code),
      this.state.loginToken
    ).then((res) => {
      if (res.response && res.response.status && res.response.status === 406) {
        this.setState({ err406: true });
        this.codeInput.current.classList.add("border-danger", "text-danger");
      }
      if (res && res.status === 200) {
        this.setState({ err406: false, codeModal: false, phoneModal: false });
        this.setToken(res.data.access_token, res.data.next);
      }
      this.setState({ pending: false });
    });
  }
  setToken(token, next) {
    Promise.resolve().then((v) => {
      localStorage.setItem(
        `${window.location.hostname}_token`,
        "GityToken " + token
      );
      if (next.action === 1) {
        window.location.href = navigate_to_edit_profile(
          window.location.pathname
        );
      } else {
        if (this.props.productId) {
          try {
            document.getElementById("product-" + this.props.productId).click();
          } catch {}
        } else {
          !this.props.notReload && window.location.reload(true);
          this.props.repeat && this.props.repeatAgain();
        }
      }
      localStorage.removeItem(`loginModal`);
    });
  }
  render() {
    return (
      <section>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
          isOpen={this.state.codeModal}
          toggle={() => {
            this.setState({ codeModal: false });
            clearInterval(this.timer);
          }}
        >
          <ModalBody className="row mx-0 p-4">
            <div
              className="row mx-0 px-0 text-center"
              style={{ marginBottom: "30px" }}
            >
              <div className="col-auto px-0 align-self-center">
                <FiChevronRight
                  size="28"
                  onClick={() =>
                    this.setState({
                      phoneModal: true,
                      codeModal: false,
                      code: "",
                    })
                  }
                />
              </div>
              {!isSiteDomain && (
                <div className="col px-0">
                  <img
                    src={require("../../assets/images/main_logo.svg").default}
                    width={isDesktop ? "50%" : "75%"}
                    className=""
                    alt="logo"
                  />
                </div>
              )}
            </div>
            <div className="col-12 text-center px-0">
              <h6 className="card-title my-3 text-center">
                کد ۴ رقمی ارسال شده به
                <span className="color-main">
                  {" " + this.state.phone + " "}
                </span>
                را وارد کنید
              </h6>
              <p className="fs-2 fw-bolder">
                {this.state.expire_time === 0 ? (
                  <button
                    className="btn fs-6 color-main"
                    onClick={() => this.submitPhone()}
                  >
                    ارسال دوباره کد
                  </button>
                ) : (
                  ~~(this.state.expire_time / 60) +
                  ":" +
                  (this.state.expire_time % 60 < 10
                    ? "0" + (this.state.expire_time % 60)
                    : this.state.expire_time % 60)
                )}
              </p>
              <input
                ref={this.codeInput}
                className="form-control mb-2 text-center rounded14 w-100 bg-gray rounded12 fs-3 mt-4"
                type="tel"
                dir="ltr"
                placeholder=" -  -  -  - "
                onChange={(e) =>
                  this.setState(
                    { code: e.target.value },
                    () => this.state.code.length === 4 && this.submitCode()
                  )
                }
                maxLength="4"
                value={this.state.code}
                autoFocus={true}
              />
              {this.state.err406 && (
                <p className="text-danger fs-6 text-center py-2">
                  کد وارد شده اشتباه است
                </p>
              )}
              <button
                className="btn bg-disabled py-2-3 bg-color-main fs-6 text-white w-100 rounded28 border-0 color-white btn-lg mt-3 mb-3"
                type="button"
                disabled={this.state.pending || this.state.code.length !== 4}
                onClick={() => this.submitCode()}
              >
                {this.state.pending ? (
                  <span
                    className="spinner-border spinner-border-sm text-white"
                    role="status"
                    style={{ verticalAlign: "middle" }}
                    aria-hidden="true"
                  />
                ) : (
                  <b>ثبت</b>
                )}
              </button>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          id="modal"
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
          isOpen={this.state.phoneModal}
          toggle={(e) => {
            this.setState({ phoneModal: !this.state.phoneModal });
            localStorage.removeItem("loginModal");
          }}
          onOpened={() => this.setState({ showSlider: true })}
        >
          <ModalBody className="row mx-0 p-4">
            {!isSiteDomain && (
              <div className="text-center" style={{ marginBottom: "30px" }}>
                <img
                  src={require("../../assets/images/main_logo.svg").default}
                  width={isDesktop ? "50%" : "75%"}
                  className=""
                  alt="logo"
                />
              </div>
            )}
            {this.state.showSlider && this.state.introItems && (
              <div className="col-12 px-0" dir="ltr">
                <Carousel
                  className="mb-4"
                  autoPlay={false}
                  responsive={this.state.responsive}
                  showDots={this.state.introItems.length !== 1}
                  infinite={false}
                  draggable={true}
                  swipeable={true}
                  keyBoardControl={true}
                  arrows={false}
                  sliderClass="mb-4"
                  containerClass="carousel-container"
                  dotListClass="custom-dot-list-style"
                >
                  {this.state.introItems.map((item, i) => (
                    <div className="row mx-0">
                      <div className="col-12 px-0 text-center">
                        <img
                          src={item.media.file}
                          height="100"
                          className=""
                          alt="logo"
                        />
                        <p className="fw-bold fs-4">{item.title}</p>
                        <p className="fw-bold small text-secondary" dir="rtl">
                          {item.des}
                        </p>
                      </div>
                    </div>
                  ))}
                </Carousel>
              </div>
            )}
            <p className="fw-bold mb-3">برای ادامه لطفا وارد شوید</p>
            <div className="col-12 px-0 position-relative">
              <input
                placeholder="شماره تلفن همراه"
                type="tel"
                dir={this.state.phone ? "ltr" : "rtl"}
                onFocus={(e) => {
                  e.target.dir = "ltr";
                  e.target.placeholder = "";
                  isMobile && this.setState({ showSlider: false });
                }}
                onBlur={() => isMobile && this.setState({ showSlider: true })}
                maxLength="11"
                value={this.state.phone}
                onChange={(e) =>
                  this.setState({
                    phone: fix_numbers.fixNumbers(e.target.value),
                  })
                }
                className="rounded14 w-100 form-control p-3"
              />
              {this.state.phone && (
                <span
                  className="color-main fs-7 px-2 position-absolute bg-white"
                  style={{ top: "-8px", right: "22px" }}
                >
                  شماره تلفن همراه
                </span>
              )}
            </div>
            <button
              disabled={
                !this.state.phone ||
                !this.state.phone.startsWith("09") ||
                this.state.phone.length !== 11 ||
                this.state.pending
              }
              className="w-100 btn rounded28 mt-3 py-2-3 bg-color-main text-white bg-disabled"
              onClick={() => {
                this.submitPhone();
                this.setState({ phoneModal: false });
              }}
            >
              {this.state.pending ? (
                <span
                  className="spinner-border spinner-border-sm text-white"
                  style={{ verticalAlign: "middle" }}
                />
              ) : (
                <b>ورود</b>
              )}
            </button>
          </ModalBody>
        </Modal>
      </section>
    );
  }
}

export default LoginModal;
